// src/Login.jsx
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import "./Login.css"; // 👈 Ensure this exists

const backgroundStyle = {
  background: "url('/background.png') center/cover no-repeat",
  minHeight: "100vh"
};

function Login({ setToken }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("http://localhost:5002/auth/login", {
        username,
        password,
      });
      const { token, role } = response.data;
      setToken(token);
      localStorage.setItem("token", token);
      localStorage.setItem("role", role);

      if (role === 1) navigate("/dashboard");
      else if (role === 0) navigate("/admindashboard");
    } catch (error) {
      alert("Login failed: " + error.response?.data?.error || "Server error");
    }
  };

  return (
    <div className="login-page" style={backgroundStyle}>
      <div className="login-box">
        <h1 className="login-title">LOGIN</h1>

        <form onSubmit={handleSubmit}>
          <label>Username/ Email</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter your username"
            required
          />

          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />

          <p className="signup-link">
            Don't have an account?{" "}
            <span onClick={() => navigate("/register")}>
              click here to sign up
            </span>
          </p>

          <button type="submit" className="login-button">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
